import { SUBMIT_ITEM_TO_SHOPPING_CART } from 'constants/shopping-cart';

const initialState = {
  isFetching: false,
  data: {},
  error: null,
};

export const postSubmitShoppingReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case `${SUBMIT_ITEM_TO_SHOPPING_CART}_PENDING`: {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    }
    case `${SUBMIT_ITEM_TO_SHOPPING_CART}_FULFILLED`: {
      return {
        ...state,
        isFetching: false,
        data: payload,
        error: null,
      };
    }
    case `${SUBMIT_ITEM_TO_SHOPPING_CART}_REJECTED`: {
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};
